/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CategoryWithControlsDto } from './CategoryWithControlsDto';
import {
    CategoryWithControlsDtoFromJSON,
    CategoryWithControlsDtoFromJSONTyped,
    CategoryWithControlsDtoToJSON,
    CategoryWithControlsDtoToJSONTyped,
} from './CategoryWithControlsDto';
import type { GroupDto } from './GroupDto';
import {
    GroupDtoFromJSON,
    GroupDtoFromJSONTyped,
    GroupDtoToJSON,
    GroupDtoToJSONTyped,
} from './GroupDto';

/**
 * 
 * @export
 * @interface FunctionWithCategoriesAndControlsDto
 */
export interface FunctionWithCategoriesAndControlsDto {
    /**
     * 
     * @type {GroupDto}
     * @memberof FunctionWithCategoriesAndControlsDto
     */
    _function?: GroupDto;
    /**
     * 
     * @type {Array<CategoryWithControlsDto>}
     * @memberof FunctionWithCategoriesAndControlsDto
     */
    categories?: Array<CategoryWithControlsDto>;
}

/**
 * Check if a given object implements the FunctionWithCategoriesAndControlsDto interface.
 */
export function instanceOfFunctionWithCategoriesAndControlsDto(value: object): value is FunctionWithCategoriesAndControlsDto {
    return true;
}

export function FunctionWithCategoriesAndControlsDtoFromJSON(json: any): FunctionWithCategoriesAndControlsDto {
    return FunctionWithCategoriesAndControlsDtoFromJSONTyped(json, false);
}

export function FunctionWithCategoriesAndControlsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunctionWithCategoriesAndControlsDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_function': json['function'] == null ? undefined : GroupDtoFromJSON(json['function']),
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(CategoryWithControlsDtoFromJSON)),
    };
}

export function FunctionWithCategoriesAndControlsDtoToJSON(json: any): FunctionWithCategoriesAndControlsDto {
    return FunctionWithCategoriesAndControlsDtoToJSONTyped(json, false);
}

export function FunctionWithCategoriesAndControlsDtoToJSONTyped(value?: FunctionWithCategoriesAndControlsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'function': GroupDtoToJSON(value['_function']),
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(CategoryWithControlsDtoToJSON)),
    };
}

